import { track } from './core';

export function trackNavPageViewed(eventName) {
  track(eventName);
}

export function trackNavAppViewed(appId, appName) {
  track('nav_app_viewed', { app_id: appId, app_name: appName });
}

export function trackNavReportViewed(appId, appName) {
  track('nav_report_viewed', { app_id: appId, app_name: appName });
}
